import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { IPage } from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
})
export class PageComponent implements OnInit {

  page: IPage = {
    id: 'loading',
    title: 'Loading',
    content: ''
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private logger: LoggerService,
  ) { }

  ngOnInit(): void {
    // Test if there is a page to fetch
    const p = this.service.getPage();
    if (! p) {
      this.closePopup();
      return;
    }
    window.scroll(0, 0);

    // Fetch the page
    this.service.getHttpPage()
      .subscribe(
        (resp) => this.handleSuccess(resp),
        (error) => this.service.handleError(error)
      );
  }

  /**
   * Populate page modal on footer
   */
  private handleSuccess(resp: HttpResponse<any>) {
    this.page = {
      id: resp.body.id,
      title: resp.body.title,
      content: resp.body.content
    };
  }

  closePopup() {
    // Providing a `null` value to the named outlet
    // clears the contents of the named outlet
    this.router.navigate([{ outlets: { popup: null }}]);
  }
}





